import React from 'react';

import { connect } from 'react-redux';

import { userActions } from '../../_actions';
import './login.css';
import 'bootstrap/dist/css/bootstrap.min.css';



class RedirectingLoginPage extends React.Component {
    constructor(props) {
        super(props);


        this.props.dispatch(userActions.logout());

        this.state = {
            email: '',
            password: '',
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        localStorage.clear();

        const queryParams = new URLSearchParams(window.location.search);
        const auth_key = queryParams.get('auth_key');

        if (auth_key) {
            const authKeyCleaned = auth_key.replace(/^"|"$/g, "");


            const data = {
                auth_key: authKeyCleaned,
            };

            const { dispatch } = this.props;
            dispatch(userActions.login(data));
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });

        const data = {
            email: this.state.email.toLowerCase(),
            password: this.state.password
        }


        const { dispatch } = this.props;
        if (this.state.email && this.state.password) {
            dispatch(userActions.login(data));
        }
    }

    render() {
        const { alert } = this.props;
        const { loggingIn } = this.props;
        const { email, password, submitted } = this.state;


        return (
            <div className='expired-page'>

                <div className="invalid-link-reasons" style={{ color: 'white', background: 'grey', opacity: '0.7', padding: '50px' }}>
                    <h3 className="expiry-link-heading" style={{ color: 'white' }} >...redirecting</h3>
                    <p>This could be because:</p>
                    <ol>
                        <li>You have left the assessment without completing it. Go to the email and find the link to continue assessment.</li>
                        <li>Delay in loading assessment.</li>

                    </ol>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {

    const { loggingIn } = state.authentication;
    const { alert } = state;
    return {
        loggingIn,
        alert
    };
}

const connectedLoginPage = connect(mapStateToProps)(RedirectingLoginPage);
export { connectedLoginPage as RedirectingLoginPage };




// WEBPACK FOOTER //
// ./src/_pages/RedirectingLogin/RedirectLoginPage.jsx